import { Position, PositionRange } from '../../types'

export type AudioChunkProps =
  | {
      start: Position
      end: Position
    }
  | {
      start: Position
      length: Position
    }

export class AudioChunk {
  public start: Position
  public end: Position
  public length: Position

  constructor(props: AudioChunkProps) {
    this.start = props.start
    this.length = 'length' in props ? props.length : props.end - props.start
    this.end = 'end' in props ? props.end : props.length + props.start
  }

  public cut([start, end]: PositionRange): AudioChunk | AudioChunk[] {
    if (start === end) {
      return this
    }
    if (this.start > end) {
      // --------CHUNK
      // --CUT--------

      return new AudioChunk({
        start: this.start - end + start,
        length: this.length,
      })
    }
    if (this.end < start) {
      // ---CHUNK---------
      // ----------CUT----

      return this
    }
    if (this.start >= start && this.end <= end) {
      // -----CHUNK---
      // ----C  U  T----

      return []
    }
    if (this.start < start && this.end > end) {
      // ---CHUNK---
      // ----CUT----

      return [new AudioChunk({ start: this.start, end: start }), new AudioChunk({ start, length: this.end - end })]
    }
    if (this.start >= start) {
      // -----CHUNK---
      // ----CUT------

      return new AudioChunk({
        start,
        length: this.end - end,
      })
    } else {
      // ---CHUNK-----
      // ------CUT----

      return new AudioChunk({
        start: this.start,
        end: start,
      })
    }
  }
}
